import React, { FC, memo } from 'react';
import ReactCountryFlag from "react-country-flag";
import UserAgent from './UserAgent';
import styles from './DeviceIdentityCell.module.scss';
import getCountryName from './CountryUtil';

interface DeviceIdentityCellProps {
    userIP: string;
    userCountryCode: string;
    userAgentStr: string;
    onCopyUserIP?: () => void;
    onCopyUserCountry?: () => void;
    onCopyUserAgent?: () => void;
}

const DeviceIdentityCell: FC<DeviceIdentityCellProps> = ({
    userAgentStr,
    userIP,
    userCountryCode,
    onCopyUserIP,
    onCopyUserCountry,
    onCopyUserAgent,
}) => {
    const countryName = getCountryName(userCountryCode);
    return (
    	<div className={styles['cell-wrapper']}>
        	{userIP && <code className={styles['ip-text']} onClick={onCopyUserIP}>{userIP}</code>}
            {!!userCountryCode && (
                <span onClick={onCopyUserCountry} className={onCopyUserCountry ? styles.clickable : undefined}>
                    <ReactCountryFlag title={countryName} countryCode={userCountryCode} svg style={{
                        width: '2em',
                        height: '2em',
                    }} />
                </span>
            )}
        	{userAgentStr && <UserAgent userAgentStr={userAgentStr} onClick={onCopyUserAgent} />}
    	</div>
	);
}

export default memo(DeviceIdentityCell);
